export const LIST_WARNINGS_URL = '/api/v1/warning/'

